import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";

import {
  formatCurrency,
  formatNumber,
  formatShortDate,
  getTimezoneDate,
  timezones,
} from "../../utilities/helpers";

export default function SeasonReport({ data }) {
  let individualCountTotal = data.reduce(
    (acc, cur) => acc + cur?.individualTicketCount,
    0,
  );

  let individualSalesTotal = data.reduce(
    (acc, cur) => acc + cur?.individualSum,
    0,
  );

  let groupCountTotal = data.reduce(
    (acc, cur) => acc + cur?.groupTicketCount,
    0,
  );

  let groupSalesTotal = data.reduce((acc, cur) => acc + cur?.groupSum, 0);

  let seasonCountTotal = data.reduce(
    (acc, cur) => acc + cur?.seasonTicketCount,
    0,
  );

  let seasonSalesTotal = data.reduce((acc, cur) => acc + cur?.seasonSum, 0);

  let totalRowCounts = data.reduce(
    (acc, cur) => acc + cur?.totalRowTicketCount,
    0,
  );

  return (
    <Card className="card--md card-with-border">
      <Card.Body className="py-0">
        <Table>
          <thead>
            <tr className="with-inside-borders lg">
              <th colSpan={3}></th>
              <th colSpan={2} className="uppercase">
                Individual Tickets
              </th>
              <th colSpan={2} className="uppercase">
                Group Tickets
              </th>
              <th colSpan={2} className="uppercase">
                Season Tickets
              </th>
              <th className="uppercase">Row Totals</th>
            </tr>
            <tr>
              <th colSpan={2}>Event name</th>
              <th>Event date</th>
              <th className="border-start">Quantity</th>
              <th className="border-end">Sales</th>
              <th className="border-start">Quantity</th>
              <th className="border-end">Sales</th>
              <th className="border-start">Quantity</th>
              <th className="border-end">Sales</th>
              <th className="border-start">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {data.map((d, i) => (
              <tr key={i}>
                <td colSpan={2}>{d?.event?.name}</td>
                <td>
                  {formatShortDate(
                    getTimezoneDate(
                      d?.event?.start,
                      timezones(d?.event?.venue[0]?.timezone),
                    ),
                    "dateOnly",
                  )}
                </td>
                <td className="border-start">
                  {formatNumber(d?.individualTicketCount)}
                </td>
                <td className="border-end">
                  {formatCurrency(d?.individualSum)}
                </td>
                <td className="border-start">
                  {formatNumber(d?.groupTicketCount)}
                </td>
                <td className="border-end">{formatCurrency(d?.groupSum)}</td>
                <td className="border-start">
                  {formatNumber(d?.seasonTicketCount)}
                </td>
                <td className="border-end">{formatCurrency(d?.seasonSum)}</td>
                <td>{formatNumber(d?.totalRowTicketCount)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="lg total-row">
              <td colSpan={3}>Grand Totals</td>
              <td className="border-start">
                {formatNumber(individualCountTotal)}
              </td>
              <td className="border-end">
                {formatCurrency(individualSalesTotal)}
              </td>
              <td className="border-start">{formatNumber(groupCountTotal)}</td>
              <td className="border-end">{formatCurrency(groupSalesTotal)}</td>
              <td className="border-start">{formatNumber(seasonCountTotal)}</td>
              <td className="border-end">{formatCurrency(seasonSalesTotal)}</td>
              <td>{formatNumber(totalRowCounts)}</td>
            </tr>
          </tfoot>
        </Table>
      </Card.Body>
    </Card>
  );
}
